import {Component} from "@angular/core";
import {AccountTypeSearchModel} from "../account-type-search.model";
import {AccountTypeEntityModel} from "../account-type-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-account-type-search-page",
    templateUrl: "./account-type-search-page.component.html",
    providers: [provideSearchModel(AccountTypeSearchModel), provideEntityModel(AccountTypeEntityModel)]
})
export class AccountTypeSearchPageComponent extends AbstractSearchPage {

}


